import React, { useState, useEffect } from 'react';
import { MdSearch } from 'react-icons/md';
import { states, lgas, propertyTypes } from '../data/PropertyData';
import { NewLGA } from "../data/NewLGA";

const SearchArea = ({ setData, properties }) => {

  const [state, setState] = useState("")
  const [lga, setLga] = useState("")
  const [propertyType, setPropertyType] = useState("")
  const [beds, setBeds] = useState("")
  const [baths, setBaths] = useState("")
  const [price, setPrice] = useState("")

  const [newLga, setNewLga] = useState([])

  const num = [1,2,3,4,5,"6+"]

  useEffect(() => {
    NewLGA({state, lgas, setNewLga })
  }, [state])

  const handleSearchData = (e) => {
    e.preventDefault()
    const results = properties?.data?.filter(item => (
      item.state === state && 
      item.lga === lga && 
      item.propertyType === propertyType &&
      item.bedrooms >= beds &&
      item.bath >= baths &&
      item.price >= price ))
    setData(results)
  }

  return (
    <div className="search-area">
      <form onSubmit={handleSearchData}>
        <div className="form-grp">
          <label htmlFor="state">State</label>
          <select id="state" value={state} onChange={(e) => setState(e.target.value)} required>
            <option value={""}>Select State</option>
            {states.map((item, index) => 
              <option key={index} value={item}>{item}</option>
            )}
          </select>
        </div>
        <div className="form-grp">
          <label htmlFor="lga">L.G.A</label>
          <select id="lga" value={lga} onChange={(e) => setLga(e.target.value)} required>
            <option>Select L.G.A</option>
            {state && 
              newLga.map((item, index) => 
                <option key={index} value={item}>{item}</option>
              )
            }
          </select>
        </div>
        <div className="form-grp">
          <label htmlFor="type">Property Type</label>
          <select id="type" value={propertyType} onChange={(e) => setPropertyType(e.target.value)} required>
            <option>Select Property Type</option>
            {propertyTypes.map((item, index) => 
              <option key={index} value={item}>{item}</option>
            )}                                                             
          </select>
        </div>
        <div className="form-grp_sub">
          <div className="form-grp">
            <label htmlFor="beds">Beds</label>
            <select id="beds" value={beds} onChange={(e) => setBeds(e.target.value)} required>
              {num.map((item, index) => 
                <option key={index} value={item}>{item}</option>
              )}
            </select>
          </div>
          <div className="form-grp">
            <label htmlFor="baths">Baths</label>
            <select id="baths" value={baths} onChange={(e) => setBaths(e.target.value)} required>
              {num.map((item, index) => 
                <option key={index} value={item}>{item}</option>
              )}
            </select>
          </div>
        </div>
        <div className="form-grp">
          <label htmlFor="price">Price Limit</label>
          <input type="number" placeholder="₦" value={price} onChange={(e) => setPrice(e.target.value)} required/>
        </div>
        <div className="search-btn">
          <button type="submit"><MdSearch size={20}/></button>
        </div>
      </form>
    </div>
  )
}

export default SearchArea;